import { CART_KEY, state } from "./state.js";

function loadRaw() {
  try {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveRaw(lines) {
  localStorage.setItem(CART_KEY, JSON.stringify(lines));
  window.dispatchEvent(new CustomEvent("ck-cart-change"));
}

export function getCart() {
  return loadRaw();
}

export function cartCount() {
  return loadRaw().reduce((n, line) => n + (line.qty || 0), 0);
}

export function setCartQty(slug, qty, name) {
  const lines = loadRaw();
  const q = Math.max(0, Math.floor(Number(qty) || 0));
  const idx = lines.findIndex((l) => l.slug === slug);
  if (q <= 0) {
    if (idx >= 0) lines.splice(idx, 1);
  } else if (idx >= 0) {
    lines[idx].qty = q;
    if (name) lines[idx].name = name;
  } else {
    const detail = state.details?.[slug];
    lines.push({
      slug,
      name: name || detail?.name || slug,
      qty: q,
      colour: detail?.colour || "4A8B6F",
    });
  }
  saveRaw(lines);
}

export function addToCart(slug, qty = 1, name) {
  const lines = loadRaw();
  const add = Math.max(1, Math.floor(Number(qty) || 1));
  const idx = lines.findIndex((l) => l.slug === slug);
  if (idx >= 0) {
    lines[idx].qty += add;
  } else {
    const detail = state.details?.[slug];
    lines.push({
      slug,
      name: name || detail?.name || slug,
      qty: add,
      colour: detail?.colour || "4A8B6F",
    });
  }
  saveRaw(lines);
}

export function addManyToCart(entries) {
  for (const e of entries) {
    if (!e?.slug) continue;
    addToCart(e.slug, e.qty ?? 1, e.name);
  }
}

export function clearCart() {
  saveRaw([]);
}

/** Expand craft targets into raw materials using first recipe of each item. */
export function expandToRaw(lines = loadRaw()) {
  const need = new Map();

  function addNeed(slug, qty, name, colour) {
    const prev = need.get(slug) || { slug, name, colour, qty: 0 };
    prev.qty += qty;
    prev.name = name || prev.name;
    prev.colour = colour || prev.colour;
    need.set(slug, prev);
  }

  function expand(slug, qty, stack = new Set()) {
    const detail = state.details?.[slug];
    if (!detail) {
      addNeed(slug, qty, slug, "4A8B6F");
      return;
    }
    const recipe = (detail.recipes || [])[0];
    if (!recipe || !recipe.inputs?.length) {
      addNeed(slug, qty, detail.name, detail.colour);
      return;
    }
    if (stack.has(slug)) {
      addNeed(slug, qty, detail.name, detail.colour);
      return;
    }
    stack.add(slug);
    const outQty = recipe.outputQty || 1;
    const crafts = Math.ceil(qty / outQty);
    for (const inp of recipe.inputs) {
      const childSlug = inp.item?.slug;
      if (!childSlug) continue;
      expand(childSlug, (inp.qty || 1) * crafts, new Set(stack));
    }
  }

  for (const line of lines) {
    expand(line.slug, line.qty || 1);
  }

  return [...need.values()].sort((a, b) => a.name.localeCompare(b.name));
}
